<script setup lang="ts">
import { IconFont } from '@mp/component'
import Notice from '@/components/Notice/index.vue'
import { computed } from 'vue'
import { messageRecordReadStatusStats } from '@mp/api/sdpMessage/MessageV2Controller.ts'
import { useQuery } from '@tanstack/vue-query'
import WujieVue from 'wujie-vue3'

const { bus } = WujieVue

// #查询消息数量
const { data: messageStats, refetch: refetchReadStatusStats } = useQuery({
  queryKey: ['message/record/read-status-stats'],
  queryFn: () => messageRecordReadStatusStats({
    targetAppId: 'WEB_B',
  }),
  select: res => res.series?.filter(item => Boolean(item.messageType)),
})

// ?计算总和
const unreadCountTotal = computed(() => {
  return messageStats.value?.reduce((prev, cur) => prev + (cur.unreadCount || 0), 0)
})

bus.$on('notice:detail:close', () => {
  refetchReadStatusStats()
})
</script>

<template>
  <div class="flex items-center">
    <el-badge :value="unreadCountTotal" :show-zero="false" class="cursor-pointer" @click="bus.$emit('notice:open')">
      <IconFont type="icon-bell" class="text-xl inline-block -translate-y-[1px] leading-none mr-0" />
      消息
    </el-badge>
  </div>

  <Notice />
</template>
